// src/ui/Header.js
const LANGUAGES = [
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
  { code: 'ar', flag: '🇸🇦', label: 'العربية' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
];

export class Header {
  constructor({ langManager, installManager, themeManager }) {
    this._lm = langManager;
    this._im = installManager;
    this._tm = themeManager;
    this._el = this._build();
  }

  get element() { return this._el; }

  _build() {
    const header = document.createElement('header');
    header.className = 'app-header';

    // Logo
    const logo = document.createElement('span');
    logo.className = 'logo';
    logo.setAttribute('aria-label', 'HTTTC home');
    logo.innerHTML = `HTTTC<span class="logo-dot" aria-hidden="true"></span>`;

    // Actions
    const actions = document.createElement('div');
    actions.className = 'header-actions';

    // Language switcher
    const langBtn = document.createElement('button');
    langBtn.className = 'icon-btn';
    langBtn.type = 'button';
    langBtn.setAttribute('aria-label', 'Switch language');
    langBtn.setAttribute('aria-haspopup', 'true');
    langBtn.innerHTML = `<i class="ti ti-world" aria-hidden="true"></i>`;

    const langDropdown = document.createElement('div');
    langDropdown.className = 'dropdown';
    langDropdown.setAttribute('role', 'menu');

    LANGUAGES.forEach(({ code, flag, label }) => {
      const item = document.createElement('button');
      item.className = 'dropdown-item' + (code === this._lm.lang ? ' active' : '');
      item.type = 'button';
      item.role = 'menuitem';
      item.innerHTML = `<span aria-hidden="true">${flag}</span> ${label}`;
      item.addEventListener('click', () => {
        this._lm.set(code);
        langDropdown.querySelectorAll('.dropdown-item').forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        langDropdown.classList.remove('open');
      });
      langDropdown.appendChild(item);
    });

    langBtn.appendChild(langDropdown);
    langBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      langDropdown.classList.toggle('open');
    });

    // Close lang dropdown on outside click
    document.addEventListener('click', () => langDropdown.classList.remove('open'));

    // Theme toggle button
    const themeBtn = document.createElement('button');
    themeBtn.className = 'icon-btn';
    themeBtn.type = 'button';
    this._themeBtn = themeBtn;
    this._updateThemeBtn();
    themeBtn.addEventListener('click', () => {
      this._tm.toggle();
      this._updateThemeBtn();
    });

    // PWA install button
    const installBtn = document.createElement('button');
    installBtn.className = 'install-btn';
    installBtn.type = 'button';
    installBtn.setAttribute('aria-label', this._lm.t('install.button'));
    installBtn.innerHTML = `
      <i class="ti ti-download" aria-hidden="true" style="font-size:16px;"></i>
      <span class="install-label">${this._lm.t('install.button')}</span>
    `;
    installBtn.addEventListener('click', () => this._im.prompt());

    this._im.onAvailabilityChange((available) => {
      installBtn.classList.toggle('visible', available);
    });

    this._installBtn = installBtn;

    actions.appendChild(langBtn);
    actions.appendChild(themeBtn);
    actions.appendChild(installBtn);
    header.appendChild(logo);
    header.appendChild(actions);

    return header;
  }

  _updateThemeBtn() {
    const dark = this._tm.isDark;
    this._themeBtn.innerHTML = `<i class="ti ${dark ? 'ti-sun' : 'ti-moon'}" aria-hidden="true"></i>`;
    this._themeBtn.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
  }

  updateTranslations() {
    const installLabel = this._installBtn.querySelector('.install-label');
    if (installLabel) installLabel.textContent = this._lm.t('install.button');
    this._installBtn.setAttribute('aria-label', this._lm.t('install.button'));
  }
}
